import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DeleteNotificationParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class DeleteNotificationApiMutation extends ApiMutation<
	void,
	DeleteNotificationParams
> {
	client = 'messaging';
	document = gql`
		mutation DeleteNotification($id: UUID!) {
			deleteNotification(id: $id)
		}
	`;
	method = 'deleteNotification';
}
